import React from "react";
import "./AccessDenied.css";

export default function AccessDenied() {
  return (
    <div className="access-body">
      <div className="access-inner">
        <i className="fa fa-lock"></i>
        <h2>Access denied</h2>
        <h4>You don't have permission to access this page.</h4>
        <p>
          Contact an administrator to get permission or go back to home page and
          browse other pages.
        </p>
      </div>
    </div>
  );
}
